import DocumentiSocioView from "./DocumentiSocioView";
import axios from "axios";
import {useContext, useEffect, useState} from "react";
import {LoaderContext} from "../../context/LoaderContext";
import {downloadDoc} from "../../utility/common";

export default function DocumentiSocioController() {

    const [documentiSocio, setDocumentiSocio] = useState([]);
    const [show, setShow] = useState(false);
    const [modalMsg, setModalMsg] = useState(false);

    const {startChiamata, endChiamata} = useContext(LoaderContext);

    function getDocumentiSocio() {
        startChiamata()
        axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/documenti-socio/`).then((response) => {
            setDocumentiSocio(response.data.data)
            endChiamata()
        });
    }

    useEffect(() => {
        getDocumentiSocio();
    }, []);

    const downloadDocumento = (doc) => {
        startChiamata();
        axios.get(process.env.REACT_APP_API_ENDPOINT + "/api/rfi/documenti-socio/" + doc.id_documento_soci).then((response) => {
            if (response.data.result === -1) {
                setModalMsg(response.data.description);
                setShow(true);
            } else {
                let resp = response.data.data;
                if (resp) {
                    downloadDoc(resp)
                }
            }
            endChiamata();
        });
    }

    return (
        <DocumentiSocioView
            documenti={documentiSocio}
            downloadDocumento={downloadDocumento}
            showMsg={show}
            setShowMsg={setShow}
            modalMsg={modalMsg}
        />
    );

}